// extracted by mini-css-extract-plugin
module.exports = {"container":"IssueDescription_container_2fQpQ","label":"IssueDescription_label_WclCF"};